import React, { Component } from 'react';
import { evaluate } from '@tencent/workbench';
import Tooltip from '@tencent/dui/lib/components/Tooltip';
import DragAngleCircle from './angle-circle.js';
import { NumberInput } from '../base/number-input.js';
import formStyle from '../form-item.less.js';
import { lit } from '../../../utils/literal.js';
import Style from './angle.less.js';

/**
 * @public
 * @deprecated
 * Angle 组件会移入 DUI，2.0 版本后，Form 扩展不再通过枚举提供此变量
 */
const AngleFrom = {
    CIRCLE: lit('circle'),
    INPUT: lit('input'),
    ADD_BTN: lit('add-btn'),
    REDUCE_BTN: lit('reduce-btn'),
};
class AngleFormItem extends Component {
    constructor() {
        var _a;
        super(...arguments);
        this.value = (_a = this.props.defaultValue) !== null && _a !== void 0 ? _a : 135;
        this.handleAngleChange = (value, from, dragState) => {
            var _a, _b;
            const notNumber = value ? isNaN(parseInt(value, 10)) : false;
            const angle = (notNumber || !value) ? 0 : parseInt(value, 10);
            this.value = value === '' || typeof value === 'object' || value === '°' ? null : angle;
            (_b = (_a = this.props).onChange) === null || _b === void 0 ? void 0 : _b.call(_a, this.value, from, dragState);
            this.forceUpdate();
        };
    }
    render() {
        var _a, _b, _c, _d;
        const { label, tooltip } = this.props;
        const tooltipText = evaluate(tooltip, null);
        const value = evaluate(this.props.value, this.value);
        const options = evaluate(this.props.options, {});
        return React.createElement("div", { className: formStyle['form-item-group'] },
            label && React.createElement("label", { className: Style.label },
                React.createElement(Tooltip, { title: tooltipText, disabled: !tooltipText }, label)),
            React.createElement(DragAngleCircle, { onAngleChange: (angleVal, dragState) => this.handleAngleChange(angleVal, AngleFrom.CIRCLE, dragState), angle: value !== null && value !== void 0 ? value : 0 }),
            React.createElement(NumberInput, Object.assign({}, options, { onChange: this.handleAngleChange, value: `${value !== null && value !== void 0 ? value : ''}`, suffix: "\u00B0", step: (_a = options === null || options === void 0 ? void 0 : options.step) !== null && _a !== void 0 ? _a : 1, maxLength: (_b = options === null || options === void 0 ? void 0 : options.maxLength) !== null && _b !== void 0 ? _b : 4, min: (_c = options === null || options === void 0 ? void 0 : options.min) !== null && _c !== void 0 ? _c : 0, max: (_d = options === null || options === void 0 ? void 0 : options.max) !== null && _d !== void 0 ? _d : 360, style: {
                    minWidth: 60,
                }, defaultValue: this.props.defaultValue })));
    }
}

export { AngleFormItem, AngleFrom };
//# sourceMappingURL=angle.js.map
